export enum ReportType {
  /**
   * Did Not Purchase.
   */
  DNP,
  /**
   * Purchase.
   */
  P,

  /**
   * Purchase AQ.
   */
  PAQ

}

export namespace ReportType {

  export function fromString(name: string): ReportType {
    return ReportType[name];
  }

  const MEANINGS = new Map<number, string>([
    [ReportType.DNP, 'Did Not Purchase'],
    [ReportType.P, 'Purchase'],
    [ReportType.PAQ, 'Purchase AQ']
  ]);

  export function meaning(type: ReportType) {
    return MEANINGS.get(type);
  }

  export function values(): ReportType[] {
    return Array.from(MEANINGS.keys());
  }

}
